import WellnessSurveyForm from "./WellnessSurveyForm";

export default function WellnessSurveyEditPage({showGlobalSnackbar})
{
    return <WellnessSurveyForm showGlobalSnackbar={showGlobalSnackbar} isEdit={true}/>
}
